import { createSlice } from "@reduxjs/toolkit"

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: null,
    errors: [],
    displayedSeason: null
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateData: (state, action) => {
      state.data = action.payload
    },
    updateDisplayedSeason: (state, action) => {
      state.displayedSeason = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updateData, updateErrors, updateDisplayedSeason } = dashboardSlice.actions

export default dashboardSlice.reducer